// extracted by mini-css-extract-plugin
export default {"brass-multiselect":"MultiSelectCustom_brass-multiselect__ax+FP"};